import { render, staticRenderFns } from "./MHISessionTimeout.vue?vue&type=template&id=2b6fb788&scoped=true&"
import script from "./MHISessionTimeout.vue?vue&type=script&lang=js&"
export * from "./MHISessionTimeout.vue?vue&type=script&lang=js&"
import style0 from "./MHISessionTimeout.vue?vue&type=style&index=0&id=2b6fb788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6fb788",
  null
  
)

export default component.exports